import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { getUUID, useSettingsStore } from '@annunciate/core';
import { USER_UPDATE } from '@annunciate/query/dist/queries/user';
import { useMutation } from './base';
export const useSettingsMutation = () => {
    const client = useQueryClient();
    const onUpdateUserData = useCallback((userId, data) => {
        const userTheme = data?.user?.settings?.theme;
        useSettingsStore.getState().setThemeMode(userTheme);
        client.setQueryData(['user', userId], (old) => {
            return produce(old || {}, (draft) => {
                return {
                    ...draft,
                    ...data,
                };
            });
        });
    }, [client]);
    return useMutation(USER_UPDATE, {
        onMutate: (data) => {
            const userId = getUUID(true) || 'public';
            const previous = client.getQueryData(['user', userId]);
            onUpdateUserData(userId, data);
            return {
                previous,
            };
        },
        onSuccess: (data) => {
            onUpdateUserData(data.user.id, data);
        },
    });
};
//# sourceMappingURL=useSettingsMutation.js.map